// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import constants from "@store/constants";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import React, { FC } from "react";

export interface OnboardingOrderWarningProps extends WidgetProps {}

export interface OnboardingOrderWarningStyles {
    infosbox?: InfosBoxProps;
}

const onboardingOrderWarningStyles: OnboardingOrderWarningStyles = {
    infosbox: {
        type: "warning",
    },
};

const styles = onboardingOrderWarningStyles;

const OnboardingOrderWarning: FC<OnboardingOrderWarningProps> = () => {
    const currentBillTo = useAppSelector(x => getCurrentBillToState(x).value);
    const isOnboarding = getBooleanProperty(currentBillTo?.properties.isOnboarding);

    if (!isOnboarding) {
        return null;
    }

    return <InfosBox {...styles.infosbox}>{siteMessage("Cansel_Onboarding_OrderWarning")}</InfosBox>;
};

const widgetModule: WidgetModule = {
    component: OnboardingOrderWarning,
    definition: {
        group: constants.widgetGroup.onboarding,
        displayName: "Order Warning",
        icon: "circle-i",
    },
};

export default widgetModule;
